export default __webpack_public_path__ + "static/media/paypal-original.c1738259.svg";